import React, { Component } from 'react';
import { connect } from 'react-redux';
import { orderAction } from '../actions/orderAction';
import { Row, Col, Form, Button } from 'react-bootstrap';
import moment from 'moment';

function getDefaultDateRange() {
  const now = new Date();
  const firstDayPrevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const lastDayPrevMonth = new Date(now.getFullYear(), now.getMonth(), 0);
  const pad = n => n < 10 ? '0' + n : n;
  const startDate = `${firstDayPrevMonth.getFullYear()}-${pad(firstDayPrevMonth.getMonth() + 1)}-${pad(firstDayPrevMonth.getDate())}`;
  const endDate = `${lastDayPrevMonth.getFullYear()}-${pad(lastDayPrevMonth.getMonth() + 1)}-${pad(lastDayPrevMonth.getDate())}`;
  return { startDate, endDate };
}

const datePresets = [
  { value: 'today', label: 'Hôm nay' },
  { value: 'yesterday', label: 'Hôm qua' },
  { value: 'this_week', label: 'Tuần này' },
  { value: 'last_week', label: 'Tuần trước' },
  { value: 'this_month', label: 'Tháng này' },
  { value: 'last_month', label: 'Tháng trước' },
  { value: 'all', label: 'Tất cả' }
];

function getDateRangeByPreset(preset) {
  const today = moment().startOf('day');
  let from = '', to = '';
  switch (preset) {
    case 'today':
      from = today.format('YYYY-MM-DD');
      to = today.format('YYYY-MM-DD');
      break;
    case 'yesterday':
      from = today.clone().subtract(1, 'days').format('YYYY-MM-DD');
      to = from;
      break;
    case 'this_week':
      from = today.clone().startOf('week').add(1, 'days').format('YYYY-MM-DD');
      to = today.format('YYYY-MM-DD');
      break;
    case 'last_week':
      from = today.clone().subtract(1, 'weeks').startOf('week').add(1, 'days').format('YYYY-MM-DD');
      to = today.clone().subtract(1, 'weeks').endOf('week').add(1, 'days').format('YYYY-MM-DD');
      break;
    case 'this_month':
      from = today.clone().startOf('month').format('YYYY-MM-DD');
      to = today.format('YYYY-MM-DD');
      break;
    case 'last_month':
      from = today.clone().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      to = today.clone().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
      break;
    case 'all':
      from = '';
      to = '';
      break;
    default:
      from = today.format('YYYY-MM-DD');
      to = today.format('YYYY-MM-DD');
  }
  return { startDate: from, endDate: to };
}

function getBonus(deliveredCenterOrders) {
  if (deliveredCenterOrders >= 2000) return 8000000;
  if (deliveredCenterOrders >= 1500) return 4000000;
  if (deliveredCenterOrders >= 1000) return 2000000;
  if (deliveredCenterOrders > 0) return 1000000;
  return 0;
}

class FulfillTeamStat extends Component {
  constructor(props) {
    super(props);
    const { startDate, endDate } = getDefaultDateRange();
    this.state = {
      startDate,
      endDate,
      datePreset: 'last_month'
    };
  }

  componentDidMount() {
    this.fetchStats();
  }

  fetchStats = () => {
    const { startDate, endDate } = this.state;
    this.props.getFulfillTeamStat({ startDate, endDate });
  };

  handleStartDateChange = (e) => {
    this.setState({ startDate: e.target.value, datePreset: '' });
  };

  handleEndDateChange = (e) => {
    this.setState({ endDate: e.target.value, datePreset: '' });
  };

  handlePresetChange = (e) => {
    const preset = e.target.value;
    const { startDate, endDate } = getDateRangeByPreset(preset);
    this.setState({ datePreset: preset, startDate, endDate }, this.fetchStats);
  };

  render() {
    const { fulfillTeamStat, loading, error } = this.props;
    const { startDate, endDate, datePreset } = this.state;
    const delivered = fulfillTeamStat?.deliveredCenterOrders || 0;
    const bonus = getBonus(delivered);
    // Determine if the bonus should be shown (only for last_month or this_month)
    const showBonus = datePreset === 'last_month' || datePreset === 'this_month';
    return (
      <div className="container mt-4">
        <h2>Thống kê Team Fulfill</h2>
        <Form className="mb-3">
          <Row className="align-items-end">
            <Col md={3}>
              <Form.Group>
                <Form.Label>Chọn khoảng thời gian</Form.Label>
                <Form.Select value={datePreset} onChange={this.handlePresetChange}>
                  <option value="">-- Tuỳ chọn --</option>
                  {datePresets.map(p => (
                    <option key={p.value} value={p.value}>{p.label}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Từ ngày</Form.Label>
                <Form.Control type="date" value={startDate} onChange={this.handleStartDateChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Đến ngày</Form.Label>
                <Form.Control type="date" value={endDate} onChange={this.handleEndDateChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Button variant="primary" onClick={this.fetchStats} style={{ width: '100%' }}>Lấy thống kê</Button>
            </Col>
          </Row>
        </Form>
        {loading && <div>Đang tải...</div>}
        {error && <div style={{ color: 'red' }}>{error.toString()}</div>}
        {fulfillTeamStat && (
          <div className="d-flex flex-wrap gap-3 mb-4" style={{ justifyContent: 'flex-start' }}>
            <div style={{ minWidth: 220, background: '#f5f6fa', borderRadius: 8, padding: 16, boxShadow: '0 1px 4px #eee', textAlign: 'center' }}>
              <div style={{ fontWeight: 600, color: '#636e72' }}>Tổng đơn đã ship cho ĐVVC</div>
              <div style={{ fontSize: 28, fontWeight: 'bold', color: '#0984e3' }}>{delivered}</div>
            </div>
            {showBonus && (
              <div style={{ minWidth: 220, background: '#f5f6fa', borderRadius: 8, padding: 16, boxShadow: '0 1px 4px #eee', textAlign: 'center' }}>
                <div style={{ fontWeight: 600, color: '#636e72' }}>Mức thưởng</div>
                <div style={{ fontSize: 28, fontWeight: 'bold', color: '#d35400' }}>{bonus.toLocaleString()}đ</div>
              </div>
            )}
          </div>
        )}
        <h5 className="mt-4 mb-2">Bảng thưởng tháng</h5>
        <table className="table table-bordered" style={{ maxWidth: 500 }}>
          <thead>
            <tr>
              <th>Số đơn đã ship</th>
              <th>Mức thưởng</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>&lt; 1000</td><td>1.000.000đ</td></tr>
            <tr><td>1000 - 1499</td><td>2.000.000đ</td></tr>
            <tr><td>1500 - 1999</td><td>4.000.000đ</td></tr>
            <tr><td>&ge; 2000</td><td>8.000.000đ</td></tr>
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fulfillTeamStat: state.orderReducer.fulfillTeamStat,
  loading: state.orderReducer.loading,
  error: state.orderReducer.error
});

export default connect(mapStateToProps, {
  getFulfillTeamStat: orderAction.getFulfillTeamStat
})(FulfillTeamStat); 